<template>
  <div class="art-container py-10" v-if="species">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-h4">Främmande arter</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
          <v-img :src="$_getImage(species.li_image_id)"> </v-img>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
          <span class="subtitle-1 text-uppercase color-primary">{{
            species.name_lat
          }}</span>
          <h3>{{ species.name_sve }}</h3>
          <p v-html="species.text_sve"></p>
        </v-col>
      </v-row>
      <v-row
        ><v-col class="text-right">
          <v-btn
            color="primary"
            darken-2
            text
            @click="
              $router.push({
                name: 'SingleSpecies',
                params: { nameUrl: species.url }
              })
            "
          >
            Läs mer om {{ species.name_sve }}
            <v-icon right>
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </v-col></v-row
      >
    </v-container>
  </div>
</template>

<script>
import Misc from '@/mixins/Misc'
export default {
  name: 'AlienBand',
  mixins: [Misc],
  data() {
    return {
      key: null
    }
  },
  computed: {
    species() {
      let species = this.$store.getters.getAllSpecies
      species = species.filter(s => s.alien === 'on')
      return species[Math.floor(Math.random() * species.length)]
    }
  },
  methods: {}
}
</script>

<style lang="css" scoped>
.art-container {
  background-color: #ebf9e4;
  margin-top: 50px;
}
.subtitle-1 {
  color: #7ead61;
}
</style>
